<!--
 * @Author: wangzhu
 * @Date: 2021-12-29 12:49:04
 * @LastEditTime: 2022-12-29 19:27:59
 * @LastEditors: wangzhu10 wangzhu10@jd.com
-->
<template>
    <div id="page10-wrapper">
        <div class="page10-content animate__animated animate__zoomIn">
          <div class="page10-2022">
              <!-- <div class="page-title">再见2023</div> -->
              <img class="last-year" src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-17-55uy6gGgOoV0UGDCc.png"/><br>
              <span>
                2023年度关键词:
              </span>
              <div class="page-keyword">
                <span>{{ keyword.key }}</span>
              </div>
              <span class="page-keyword-tip">{{ keyword.label }}</span>
          </div>
          <div class="page10-2023">
              <!-- <div class="page-title">你好2024</div> -->
              <img class="new-year" src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-17-55OccajNcTmVG0os5.png"/>
              <br>
              <span>
                2024<br>
                愿您在技术的海洋中航行得更加顺利<br>
                不断探索新的领域<br>
                实现自己的梦想和目标<br>
                成为更好的自己<br>
              </span>
          </div>
          <div class="page-end">END</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'page10',
    props: {
        reportData: {
            required: true,
            default: () => {},
        },
    },
    computed: {
      shortDept() {
        const list = this.reportData.department.split('-')
        return list[list.length - 1]
      },
      keyword() {
        const { award, goodCoders, badge, postNum, points, viewCount } = this.reportData
        if (award.length) {
          return {
            key: '引领者',
            label: '你的光芒闪耀，正如排行榜中勇得最佳'
          }
        } else if (badge.name) {
          return {
            key: '践行者',
            label: '一枚徽章 一份荣誉 一声感谢'
          }
        } else if(goodCoders.length) {
          return {
            key: '先行者',
            label: '代码不仅是你的事业，也是你的热爱'
          }
        } else if (postNum) {
          return {
            key: '贡献者',
            label: '写文章是你的快乐，阅读它是我的荣幸'
          }
        } else if (points) {
          return {
            key: '参与者 ',
            label: '你的默默关注，我的小小确幸'
          }
        } else if(viewCount) {
          return {
            key: '品鉴者',
            label: '你的每一次驻足，是分享者前进的光'
          }
        } else {
          return {
            key: '欣赏者',
            label: '与你相遇是幸运，让你收获是荣幸'
          }
        }
      }
    },
    methods: {
        handlePre() {
            this.$emit('pre');
        },
    },
};
</script>

<style lang="less" scoped>
#page10-wrapper {
    height: 100vh;
    width: 100%;
    padding: 0 20px;
    background-image: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-16-49ctUlfjlrqySQXJA.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    overflow: hidden;
    .page10-content {
        padding-top: 20px;
        font-size: 0.4rem;
        line-height: 2.8;
        font-weight: bold;
        color: #FAFAD7;
        // text-shadow: 1px 1px #f4e8e8;
    }
    .page10-2022 {
      text-align: left;
    }
    .page10-2023 {
      margin-top: 16px;
      text-align: right;
    } 
    .page-keyword {
      width: 200px;
      height: 80px;
      background-image: url(https://storage.360buyimg.com/iast-agent/titleBg.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 22px;
      line-height: 80px;
      color: #F66F30;
      font-weight: 500;
      position: relative;
      left: -16px;
      top: -16px;
    }
    .page-keyword-tip {
      position: relative;
      top: -30px;
    }
    .page-title {
        width: 100px;
        color: #fff;
        background: #2D97E1;
        border-radius: 4px;
        margin-bottom: 20px;
        font-weight: 500;
        line-height: 1;
        padding: 6px 0;
        position: relative;
        text-align: center;
        &:after {
            position: absolute;
            display: block;
            content: '';
            width: 300px;
            height: 4px;
            bottom: -4px;
            border-radius: 4px;
            background: #D9F0F9;
        }
    }
    .report-num {
        color: #EF5C2E;
        font-weight: 500;
        font-size: 0.5rem;
    }
    .page-end {
      color: #2D97E1;
      margin-top: 20px;
      font-size: 24px;
      opacity: 0.5;
    }
    .last-year {
      height: 2.5rem;
    }
    .new-year {
      height: 2.5rem;
    }
}
@media screen and (min-width: 1980px) {
  #page10-wrapper {
    .page10-content {
      padding-top: 10vh;
    }
        .page10-2023 {
          margin-top: 10vh;
        } 
    }
}
</style>
